export function SessionsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setCustomActions({
            'login': {
                method: 'POST',
                path: XRAY_RESOURCE.LOGIN
            },
            'logout': {
                method: 'DELETE'
            },
            'getCurrent': {
                method: 'GET'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/sessions_dao.js